module.exports = __webpack_public_path__ + "static/energy_private_2-8596cf777e4ab268a7e18a313cae8939.jpg";